import script from "./JiraAppIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./JiraAppIntegration.vue?vue&type=script&setup=true&lang=js"

import "./JiraAppIntegration.vue?vue&type=style&index=0&id=b1ae818c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1ae818c"]])

export default __exports__